import { CalendarCheck, Vote } from "lucide-react";
import { formatDate, formatTime } from "@/lib/dates";

const optLabel = (o) => `${formatDate(o.date)} · ${formatTime(o.start_time)}`;

export const MakeupPoll = ({ event, child, mine, onVote, onPick }) => {
  const opts = event.makeup_options || [];
  if (event.status !== "canceled" || !opts.length) return null;
  const picked = opts.find((o) => o.id === event.makeup_picked);
  if (picked) {
    return (
      <div className="makeup-poll flex items-center gap-2" data-testid="makeup-picked">
        <CalendarCheck size={20} className="shrink-0" />
        <p className="font-bold">Makeup set: {optLabel(picked)}</p>
      </div>
    );
  }
  const total = opts.reduce((n, o) => n + o.votes, 0);
  return (
    <div className="makeup-poll space-y-2" data-testid="makeup-poll">
      <p className="ctl-label flex items-center gap-1"><Vote size={14} /> Vote for a makeup date {onVote && !child ? "(enter your child's name above)" : ""}</p>
      {opts.map((o) => {
        const pct = total ? Math.round((o.votes / total) * 100) : 0;
        return (
          <div key={o.id} className="makeup-opt" data-testid={`makeup-option-${o.id}`}>
            <div className="makeup-bar" style={{ width: `${pct}%` }} />
            <div className="relative flex items-center gap-2">
              <div className="min-w-0 flex-1">
                <p className="font-bold">{optLabel(o)}</p>
                <p className="text-xs font-mono font-bold" data-testid="makeup-votes">{o.votes} vote{o.votes === 1 ? "" : "s"} · {pct}%</p>
              </div>
              {onVote && (
                <button className={`!min-h-[44px] !text-sm ${mine === o.id ? "btn-primary" : "btn-ghost"}`} disabled={!child}
                  data-testid="makeup-vote-button" onClick={() => onVote(o)}>{mine === o.id ? "Your vote" : "Vote"}</button>
              )}
              {onPick && <button className="btn-primary !min-h-[44px] !text-sm" data-testid="makeup-pick-button" onClick={() => onPick(o)}>Pick this date</button>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
